export default "__VITE_ASSET__379afc11__"